import { SVGProps, Ref, forwardRef } from "react";

const PinnedIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 14 19"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Pinned Icon Icon"
    {...props}
  >
    <title id="Pinned Icon Icon">Pinned Icon Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.67}
      d="M6.601 11.668v5.834M3.268 5.258v1.776c0 .173 0 .26-.017.343a.834.834 0 0 1-.074.211 1.765 1.765 0 0 1-.201.279L1.667 9.502c-.554.693-.832 1.04-.832 1.332 0 .254.115.494.313.652.228.182.673.182 1.56.182h7.786c.888 0 1.332 0 1.56-.182a.834.834 0 0 0 .313-.652c0-.292-.278-.639-.832-1.332l-1.308-1.635a1.763 1.763 0 0 1-.201-.279.833.833 0 0 1-.075-.211c-.017-.083-.017-.17-.017-.343V5.258c0-.096 0-.143.006-.19a.833.833 0 0 1 .024-.125c.012-.046.03-.09.066-.18l.84-2.1c.245-.612.367-.918.316-1.164a.833.833 0 0 0-.355-.525c-.21-.139-.54-.139-1.2-.139h-6.06c-.66 0-.99 0-1.2.139a.833.833 0 0 0-.355.525c-.051.246.071.552.317 1.165l.84 2.1c.035.088.053.133.065.179.012.04.02.082.024.124.006.048.006.095.006.191Z"
    />
  </svg>
);

const ForwardRef = forwardRef(PinnedIcon);
export default ForwardRef;
